<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Formas de recebimento</h1>
                        <p class="welcome-message">
                            <button mat-icon-button routerLink="/configuracoes/financas">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Visualize e gerencie as formas de recebimento.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 header-actions">
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if(selection.hasValue()) {
                    <span>Ações ({{selection.selected.length}})</span>
                    } @else {
                    <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>

                <mat-menu #opcoesMenu="matMenu">
                    <button mat-menu-item (click)="abrirModalExcluir()" [disabled]="!selection.hasValue()">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir</span>
                    </button>
                </mat-menu>

                <button type="button" mat-flat-button class="btn-primary"
                    routerLink="/configuracoes/financas/formas-recebimento/cadastrar">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                    Nova forma de recebimento
                </button>
            </div>
        </div>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" formControlName="pesquisa"
                            placeholder="Busque por descrição da forma de recebimento">

                        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6 filter-container">
                    <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
                        <mat-icon>cleaning_services</mat-icon>
                        Limpar Filtros
                    </button>
                </div>
            </div>
        </form>

        @if(_isLoading && _dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if(_dataSource.data.length > 0) {

        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()" [disabled]="isToggleAllDisabled()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    @if (isSelecaoBloqueada(row)) {
                    <span class="row-lock-wrapper">
                        <span class="material-symbols-outlined row-lock-icon"
                            [matTooltip]="getTooltipSelecaoBloqueada(row)">
                            lock
                        </span>
                    </span>
                    } @else {
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Descrição </th>
                <td mat-cell *matCellDef="let element">
                    <div class="descricao-cell">
                        <mat-icon
                            class="material-symbols-outlined descricao-icon">{{element.googleIconClass}}</mat-icon>
                        <span>{{element.descricao}}</span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-badge" [ngClass]="element.isAtivo ? 'badge-verde' : 'badge-cinza'">
                        {{ element.isAtivo ? 'Habilitado' : 'Desabilitado' }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="favorito">
                <th mat-header-cell *matHeaderCellDef class="w-star"></th>
                <td mat-cell *matCellDef="let element" class="w-star">
                    <button mat-icon-button class="favorite-button"
                        [class.favorite-button--active]="element.isFavorito"
                        [attr.aria-pressed]="element.isFavorito"
                        [matTooltip]="element.isFavorito ? 'Favorito' : 'Definir como favorito'"
                        (click)="definirComoFavorito(element)">
                        <span class="material-symbols-outlined padrao-icon"
                            [class.padrao-icon--active]="element.isFavorito">star</span>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/financas/formas-recebimento/cadastrar', element.id]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <span class="menu-action-tooltip-wrapper"
                            [matTooltip]="getTooltipExcluir(element)"
                            [matTooltipDisabled]="!isSelecaoBloqueada(element)">
                            <button mat-menu-item (click)="abrirModalExcluir(element)"
                                [disabled]="isSelecaoBloqueada(element)">
                                <span class="material-symbols-outlined">delete</span>
                                <span>Excluir</span>
                            </button>
                        </span>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="mobile-view">
            @for (item of _dataSource.data; track item.id) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        @if (isSelecaoBloqueada(item)) {
                        <span class="material-symbols-outlined row-lock-icon"
                            [matTooltip]="getTooltipSelecaoBloqueada(item)">
                            lock
                        </span>
                        } @else {
                        <mat-checkbox (change)="$event ? selection.toggle(item) : null"
                            [checked]="selection.isSelected(item)" color="primary">
                        </mat-checkbox>
                        }
                        <div>
                            <div class="text-bold">{{item.descricao}}</div>
                        </div>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/financas/formas-recebimento/cadastrar', item.id]">
                            Editar
                        </button>
                        <button mat-menu-item (click)="definirComoFavorito(item)" [disabled]="item.isFavorito">
                            <span class="material-symbols-outlined">star</span>
                            Definir como favorito
                        </button>
                        <span class="menu-action-tooltip-wrapper"
                            [matTooltip]="getTooltipExcluir(item)"
                            [matTooltipDisabled]="!isSelecaoBloqueada(item)">
                            <button mat-menu-item (click)="abrirModalExcluir(item)"
                                [disabled]="isSelecaoBloqueada(item)">
                                Excluir
                            </button>
                        </span>
                    </mat-menu>
                </div>

                <div class="card-body-mobile">
                    <div class="card-row-mobile">
                        <span class="text-secondary">Favorito</span>
                        @if (item.isFavorito) {
                        <span class="material-symbols-outlined padrao-icon padrao-icon--active"
                            matTooltip="Favorito">star</span>
                        }
                    </div>
                    <div class="card-row-mobile">
                        <span class="text-secondary">Status</span>
                        <span class="status-badge" [ngClass]="getStatusClass(item.isAtivo)">
                            {{ item.isAtivo ? 'Habilitado' : 'Desabilitado' }}
                        </span>
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
            <button mat-button class="btn-ver-mais"
                [disabled]="_isLoading || _dataSource.data.length >= _totalRegistros" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="20"></mat-spinner>
                } @else {
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                }
            </button>
        </div>

        } @else {
        <app-empty-list [title]="'Nenhuma forma de recebimento encontrada'"
            [subTitle]="'Cadastre uma nova forma de recebimento para começar'"></app-empty-list>
        }
    </div>
</div>
